<template>
    <el-row class="add-news">
      <el-col :span="12">
        {{ id ? "Kategoriyani tahrirlash" : `Kategoriya qo'shish` }}
      </el-col>
  
      <el-col :span="24">
        <el-form label-position="top" ref="formRef" :model="productModel">
          <el-tabs v-model="activeName">
            <el-tab-pane label="UZB" name="uz">
              <el-form-item
                label="Sarlavha"
                prop="title.uz_lat"
                :rules="[{ required: true, message: 'Sarlavha majburiy (Uz)' }]"
              >
                <el-input
                  placeholder="Sarlavhani kiriting (Uz)"
                  v-model="productModel.title.uz_lat"
                  type="text"
                  autocomplete="off"
                />
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="UZB Krill" name="uz_cyr">
              <el-form-item
                label="Sarlavha"
                prop="title.uz_cyr"
                :rules="[{ required: true, message: 'Sarlavha majburiy (UzKr)' }]"
              >
                <el-input
                  placeholder="Sarlavhani kiriting (UzKr)"
                  v-model="productModel.title.uz_cyr"
                  type="text"
                  autocomplete="off"
                />
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="RU" name="ru">
              <el-form-item
                label="Sarlavha"
                prop="title.ru"
                :rules="[{ required: true, message: 'Sarlavha majburiy (Ru)' }]"
              >
                <el-input
                  placeholder="Sarlavhani kiriting (Ru)"
                  v-model.number="productModel.title.ru"
                  type="text"
                  autocomplete="off"
                />
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="ENG" name="en">
              <el-form-item
                label="Sarlavha (En)"
                prop="title.en"
                :rules="[{ required: true, message: 'Sarlavha majburiy (En)' }]"
              >
                <el-input
                  placeholder="Sarlavhani kiriting (En)"
                  v-model.number="productModel.title.en"
                  type="text"
                  autocomplete="off"
                />
              </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="KP" name="kp">
              <el-form-item
                label="Sarlavha (Kp)"
                prop="title.kr"
                :rules="[{ required: true, message: 'Sarlavha majburiy (Kp)' }]"
              >
                <el-input
                  placeholder="Sarlavhani kiriting (Kp)"
                  v-model.number="productModel.title.kr"
                  type="text"
                  autocomplete="off"
                />
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
          <el-form-item
            label="Tashabbus kategoriyasi"
            prop="initiative_category_id"
            :rules="[{ required: true, message: 'Tashabbus kategoriyasini tanlash majburiy' }]"
          >
            <el-select
              v-model="productModel.initiative_category_id"
              placeholder="Kategoriya"
              style="width: 100%"
            >
              <el-option
                v-for="category in categories"
                :value="category.id"
                :key="category.id"
                :label="category.title"
              />
            </el-select>
          </el-form-item>
  
          <div class="mt-15 text-right">
            <router-link
              to="/app/products/list"
              class="el-button el-button--danger"
            >
              Bekor qilish
            </router-link>
            <el-button type="primary" @click="submitForm(formRef)"
              >Saqlash</el-button
            >
          </div>
        </el-form>
      </el-col>
    </el-row>
  </template>
  
  <script setup>
  import { onMounted, reactive, ref } from "vue";
  import { ElMessage, ElNotification } from "element-plus";
  import store from "@/store";
  import http from "@/http";
  import router from "@/router";
  import { useRoute } from "vue-router";
  
  const uploadUrl = ref(
    `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`
  );
  const uploadHeader = ref({ Authorization: `${store.state.accessToken}` });
  const baseUrl = process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/";
  const formRef = ref();
  const loading = ref(false);
  const categories = ref([]);
  const activeName = ref("uz");
  
  const route = useRoute();
  const { id } = route.params;
  let productModel = reactive({
    title: {
      uz_lat: "",
      uz_cyr: "",
      ru: "",
      en: "",
      kr: "",
    },
    initiative_category_id: "",
    
  });
  
  const submitForm = async (formEl) => {
    if (!formEl) return;
    await formEl.validate((valid, fields) => {
      if (valid) {
        loading.value = true;
        http({
          url: `api/v1/product-categories${id ? `/${id}` : ""}`,
          data: productModel,
          method: id ? "put" : "post",
          headers: {},
        })
          .then(() => {
            router.push("/app/categories/list");
          })
          .catch((err) => {
            console.log(err);
            ElMessage.error(`Xatolik qayta urinib ko'ring`);
          })
          .finally(() => {
            loading.value = false;
          });
      } else {
        const errors = [];
        for (const keys in fields) {
          fields[keys].map((item) => {
            errors.push(item);
          });
        }
        errors.map((error) => {
          ElMessage.error(error.message);
        });
        console.log("error submit!", fields);
      }
    });
  };
  
  onMounted(() => {
    if (id) {
      http.get(`api/v1/product-categories/${id}`).then( (res ) => {
          Object.assign(productModel, res.data);
      });
    }
  
    http.get("api/v1/initiative-categories").then((res) => {
      categories.value = res.data.initiative_categories;
    });
  });
  </script>
  
  <style>
  .file-upload label {
    margin: 0 !important;
  }
  
  .add-news .el-input__wrapper {
    padding: 0 1rem !important;
  }
  
  .input-hidden .el-form-item__content {
    height: 0;
    padding: 0;
  }
  </style>
  <style scoped lang="scss">
  .linkButtons {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
    width: 450px;
    button {
      width: 100%;
    }
  }
  
  .file-upload-button {
    padding: 1rem;
    border: 1px dotted #e1e1e1;
    border-radius: 8px;
    overflow: hidden;
    color: #808080;
    display: block;
    max-width: 240px;
    cursor: pointer;
  
    &:hover {
      background-color: #e1e1e1;
    }
  
    img {
      max-width: 100%;
      object-fit: cover;
    }
  }
  
  .text-right {
    text-align: right;
  }
  
  a {
    text-decoration: none;
  }
  
  .form-row {
    display: flex;
    gap: 15px;
  }
  </style>
  